import assets from "app/assets";
import config from "config";
import gsap from "gsap";
import { Container, NineSlicePlane, TextStyle, Text, Sprite, DEG_TO_RAD, Graphics, Texture, BaseTexture, Point } from "pixi.js";
import tools from "tools";
const WIDTH = 500;
const HEIGHT = 110;
export default class SkinItem extends Container {
  constructor(id, title, textColor, price, bgColor, datas, level) {
    super();
    tools.autobind(this);
    this._id = id;
    this._title = title;
    this._textColor = textColor;
    this._price = price;
    this._bgColor = bgColor;
    this._datas = datas;
    this._level = level;
    this._bought = false;
    this._point = new Point();
    this._init();
    this._initEvents();
  }
  _init() {
    let btnTexture = assets.textures.basicWhiteBg.texture;
    this.bg = new NineSlicePlane(btnTexture, 30, 30, 30, 30);
    this.bg.tint = 0x5572ad;
    this.bg.width = WIDTH;
    this.bg.height = HEIGHT;
    this.bg.x = -this.bg.width / 2;
    this.addChild(this.bg);
    const textStyle = new TextStyle({
      fontFamily: 'Anja Eliane accent',
      fontSize: 20,
      letterSpacing: 2,
      align: "left",
      fill: this._textColor,
      stroke: '#222222',
      strokeThickness: 5
    });
    this.text = new Text(this._title, textStyle);
    this.text.y = 4;
    this.text.x = -WIDTH / 2 + 20;
    this.addChild(this.text);
    let roundedRect = new Graphics();
    roundedRect.beginFill(tools.hashtagToHexa(this._bgColor));
    roundedRect.drawRoundedRect(0, 0, 310, 55, 10);
    roundedRect.endFill();
    roundedRect.x = -WIDTH / 2 + 20;
    roundedRect.y = this.text.height + 6;
    this.addChild(roundedRect);
    let pos = 10;
    for (let i = 0; i < 5; i++) {
      let bulle = new Sprite(assets.textures[this._datas[i].texture].texture);
      bulle.tint = tools.hashtagToHexa(this._datas[i].color);
      bulle.anchor.y = .5;
      bulle.scale.set(.3);
      bulle.y = roundedRect.height / 2;
      bulle.x = pos;
      pos += bulle.width + 24;
      roundedRect.addChild(bulle);
    }
    const priceTextStyle = new TextStyle({
      fontFamily: 'Anja Eliane accent',
      fontSize: 60,
      letterSpacing: 2,
      align: "left",
      fill: 0xffffff,
      stroke: '#222222',
      strokeThickness: 5
    });
    if (config.levelProgressionMode) {
      this.btn = new NineSlicePlane(assets.textures.shopLevelBtn.texture, 40, 40, 40, 40);
      this.btn.scale.set(.5);
      this.btn.width = 270;
      this.btn.height = 120;
      this.btn.x = 100;
      this.btn.y = this.text.height + 6;
      this.addChild(this.btn);
      this.lock = new Sprite(assets.textures.lock.texture);
      this.lock.anchor.set(.5);
      this.lock.scale.set(1.3);
      this.lock.y = 50;
      this.btn.addChild(this.lock);
      const levelTextStyle = new TextStyle({
        fontFamily: 'Anja Eliane accent',
        fontSize: 42,
        letterSpacing: 2,
        align: "center",
        fill: 0xffffff,
        stroke: '#222222',
        strokeThickness: 5
      });
      this.text = new Text("Level " + this._level, levelTextStyle);
      this.text.anchor.set(.5);
      this.text.y = this.btn.height / 2 - 10;
      this.text.x = this.btn.width / 2 - this.lock.width / 2;
      this.btn.addChild(this.text);
      this.lock.x = this.text.x + this.lock.width / 2 + this.text.width / 2 + 2;
      this.selectBtn = new NineSlicePlane(assets.textures.basicWhiteBg.texture, 40, 40, 40, 40);
      this.selectBtn.tint = 0x90e5fe;
      this.selectBtn.scale.set(.5);
      this.selectBtn.width = 270;
      this.selectBtn.height = 120;
      this.selectBtn.x = 100;
      this.selectBtn.y = this.btn.y;
    } else {
      this.btn = new NineSlicePlane(assets.textures.shopBtn.texture, 40, 40, 40, 40);
      this.btn.scale.set(.5);
      this.btn.width = 250;
      this.btn.height = 120;
      this.btn.x = 100;
      this.btn.y = this.text.height + 6;
      this.addChild(this.btn);
      this.text = new Text(this._price, priceTextStyle);
      this.text.anchor.set(1, .5);
      this.text.y = this.btn.height / 2 - 10;
      this.text.x = this.btn.width - 80;
      this.btn.addChild(this.text);
      this.coinsPico = new Sprite(assets.textures.coins.texture);
      this.coinsPico.scale.set(2);
      this.coinsPico.anchor.set(1, .5);
      this.coinsPico.x = this.btn.width - 10;
      this.coinsPico.y = this.btn.height / 2 - 10;
      this.btn.addChild(this.coinsPico);
      this.selectBtn = new NineSlicePlane(assets.textures.basicWhiteBg.texture, 40, 40, 40, 40);
      this.selectBtn.tint = 0x90e5fe;
      this.selectBtn.scale.set(.5);
      this.selectBtn.width = 250;
      this.selectBtn.height = 120;
      this.selectBtn.x = 100;
      this.selectBtn.y = this.btn.y;
    }
    this.selectText = new Text("Select", priceTextStyle);
    this.selectText.anchor.set(.5);
    this.selectText.scale.set(.7);
    this.selectText.y = this.btn.height / 2 - 10;
    this.selectText.x = this.selectBtn.width / 2;
    this.selectBtn.addChild(this.selectText);
    this.addChild(this.selectBtn);
    this.check = new Sprite(assets.textures.check.texture);
    this.check.tint = 0x6be11a;
    this.check.x = this.btn.x + this.btn.width * .25;
    this.check.y = this.btn.height / 2;
    this.check.anchor.set(.5);
    this.addChild(this.check);
    this.selectBtn.visible = false;
    this.check.visible = false;
  }
  _initEvents() {
    this.interactive = true;
    this.buttonMode = true;
    this.on('pointerdown', this._onDown);
    if (config.levelProgressionMode) {
      this.on('pointerup', this._onUpProgressLevelVersion);
    } else {
      this.on('pointerup', this._onUp);
    }
    this.on('pointerupoutside', this._onOut);
    this.on('pointermove', this._update);
  }
  _onDown() {
    if (this._isDown) {
      return;
    }
    this._isDown = true;
    this.onDownTween = gsap.to(this.scale, {
      duration: .2,
      x: .93,
      y: .93
    });
  }
  async _onUp() {
    if (!this._isDown) {
      return;
    }
    this._isDown = false;
    this.onDownTween && this.onDownTween.kill();
    gsap.to(this.scale, {
      duration: .2,
      x: 1,
      y: 1
    });
    if (this._bought) {
      this._click && this._click({
        currentTarget: this,
        id: this._id
      });
    } else if (config.coins >= this._price) {
      this._bought = true;
      config.level.updateCoins(-this._price);
      this._price = 0;
      this.selected = true;
      await config.sdk.getStoreModule().save("selectedSkin", {
        value: this.themeId
      });
      config.purchasedTheme.push(this.themeId);
      await config.sdk.getStoreModule().save("purchasedTheme", {
        value: config.purchasedTheme
      });
      this._click && this._click({
        currentTarget: this,
        id: this._id
      });
    } else {
      if (!config.boosterRvConsumed) {
        config.boosterRvPopin.show();
      } else {
        config.boosterRvPopin.show();
      }
    }
  }
  _onUpProgressLevelVersion() {
    if (!this._isDown) {
      return;
    }
    this._isDown = false;
    this.onDownTween && this.onDownTween.kill();
    gsap.to(this.scale, {
      duration: .2,
      x: 1,
      y: 1
    });
    if (this._bought) {
      this._click && this._click({
        currentTarget: this,
        id: this._id
      });
    }
  }
  _onOut() {
    this._isDown = false;
    this.onDownTween && this.onDownTween.kill();
    gsap.to(this.scale, {
      duration: .2,
      x: 1,
      y: 1
    });
  }
  _getMovement(posRef, point) {
    var directionX;
    var directionY;
    posRef.x1 = posRef.x2;
    posRef.x2 = point.x;
    directionX = point.x > posRef.x1 ? 1 : -1;
    posRef.y1 = posRef.y2;
    posRef.y2 = point.y;
    directionY = point.y > posRef.y1 ? 1 : -1;
    return {
      x: directionX * tools.distance({
        x: posRef.x1,
        y: 0
      }, {
        x: posRef.x2,
        y: 0
      }),
      y: directionY * tools.distance({
        x: 0,
        y: posRef.y1
      }, {
        x: 0,
        y: posRef.y2
      })
    };
  }
  _update() {
    this._pos = this._getMovement(this._point, config.mouse);
    if (Math.abs(this._pos.x) > 1 || Math.abs(this._pos.y) > 1) {
      this._onOut();
    }
  }
  async unlock() {
    if (this._bought) {
      return;
    }
    this._bought = true;
    this.selected = true;
    await config.sdk.getStoreModule().save("selectedSkin", {
      value: this.themeId
    });
    config.purchasedTheme.push(this.themeId);
    await config.sdk.getStoreModule().save("purchasedTheme", {
      value: config.purchasedTheme
    });
    this._click && this._click({
      currentTarget: this,
      id: this._id
    });
    config.homeMenu.skin.showAlert = true;
  }
  set click(callback) {
    this._click = callback;
  }
  set selected(val) {
    this._selected = val;
    if (val) {
      this.btn.visible = false;
      this.selectBtn.visible = false;
      this.check.visible = true;
    } else {
      this.check.visible = false;
      if (this.bought) {
        this.selectBtn.visible = true;
      } else {
        this.btn.visible = true;
      }
    }
  }
  get selected() {
    return this._selected;
  }
  set bought(val) {
    this._bought = val;
    this.btn.visible = !this._bought;
    this.selectBtn.visible = this._bought;
  }
  get bought() {
    return this._bought;
  }
  get themeId() {
    return this._id;
  }
  get price() {
    return this._price;
  }
  get level() {
    return this._level;
  }
  dispose() {
    this.destroy();
  }
}
